module.exports = __webpack_public_path__ + "static/media/29COICT11.2888359e.jpg";